import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Button,
  Typography,
  IconButton,
  useMediaQuery,
  CircularProgress,
  FormControlLabel,
  Checkbox,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import MenuSection from "../components/MenuSection";
import { useCanjeStore, useProductStore } from "../hooks";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import CheckIcon from "@mui/icons-material/Check";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import QRFAA from "../images/QRs/FAA.png";
import QRFAB from "../images/QRs/FAB.png";
import QRREM from "../images/QRs/REM.png";

const DialogoEnviarFacturaPage = () => {
  const navigate = useNavigate();
  const esKiosk = JSON.parse(localStorage.getItem("esKiosk") || "false");
  const isScreenWidthLessThan600 = useMediaQuery(theme =>
    theme.breakpoints.down("sm"),
  );
  const esDUO = JSON.parse(localStorage.getItem("esDUO")) || false;
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [loading, setLoading] = useState(false); // Estado para manejar el spinner
  const [timeLeft, setTimeLeft] = useState(15); // Estado para manejar la cuenta regresiva
  const [qrImageSrc, setQrImageSrc] = useState("");
  const [imprimirChecked, setImprimirChecked] = useState(false); // Estado para el checkbox de imprimir
  const [mailChecked, setMailChecked] = useState(false); // Estado para el checkbox de mail
  const [whatsappChecked, setWhatsappChecked] = useState(false); // Estado para el checkbox de whatsapp
  const [qrChecked, setQrChecked] = useState(false); // Estado para el checkbox de QR
  const [email, setEmail] = useState(""); // Estado para el email
  const [telefono, setTelefono] = useState(""); // Estado para el teléfono
  const [showInputs, setShowInputs] = useState(false); // Estado para mostrar los inputs
  const { clearCanje } = useCanjeStore();
  const { resetProductos } = useProductStore();

  // Función para navegar a la página con o sin impresión
  const sinImpresion = () => {
    const facturaInfoString = localStorage.getItem("facturaInfo");
    const facturaInfo = JSON.parse(facturaInfoString);
    const imprimir = false;
    localStorage.setItem("limpiarArticulos", false);
    clearCanje();
    navigate("/ticket/", { state: { facturaInfo, imprimir } });
  };

  const mandarAImprimir = () => {
    const facturaInfoString = localStorage.getItem("facturaInfo");
    const facturaInfo = JSON.parse(facturaInfoString);
    const imprimir = true;
    localStorage.setItem("limpiarArticulos", false);
    clearCanje();
    navigate("/ticket/", { state: { facturaInfo, imprimir } });
  };

  // UseEffect para contar los 30 segundos y simular el clic en "No"
  // useEffect(() => {
  //   setLoading(true); // Activamos el spinner al iniciar la cuenta regresiva

  //   const countdownInterval = setInterval(() => {
  //     setTimeLeft(prev => prev - 1);
  //   }, 1000);

  //   const timeout = setTimeout(() => {
  //     setLoading(false); // Desactivamos el spinner después de 30 segundos
  //     sinImpresion(); // Ejecuta la función de "No" automáticamente
  //   }, 15000); // 30 segundos de espera

  //   // Cleanup de los intervalos
  //   return () => {
  //     clearInterval(countdownInterval);
  //     clearTimeout(timeout);
  //   };
  // }, []);

  useEffect(() => {
    const clienteStr = localStorage.getItem("cliente");
    const cliente = clienteStr ? JSON.parse(clienteStr) : null;

    if (!cliente) {
      setQrImageSrc(QRFAB); // QR para cliente nulo
    } else if (!cliente.emiteRemito && !cliente.emiteFacturayRemito) {
      setQrImageSrc(QRFAA); // QR para FAA
    } else {
      setQrImageSrc(QRREM); // QR para REM
    }
  }, []);

  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [navigate]);

  const handleBackButton = () => {
    // Función para manejar el evento cuando se presiona el botón de retroceso
    // Aquí puedes redirigir a otra página o simplemente hacer nada
    navigate("/formasdepagopage"); // Redirecciona a otra página según sea necesario
  };

  const handleAceptar = () => {
    // Si ya están visibles los inputs, continuar flujo
    
    if(esKiosk){
      resetProductos();
      localStorage.setItem("productos", JSON.stringify([]));
      localStorage.setItem("comanda", JSON.stringify([]));
    }
    if (showInputs) {
      if (imprimirChecked) {
        mandarAImprimir();
      } else {
        sinImpresion();
      }
      return;
    }

    // Si se seleccionó Mail o WhatsApp y aún no se muestran los inputs
    if ((mailChecked || whatsappChecked || qrChecked) && !showInputs) {
      setShowInputs(true);
      return;
    }

    // Si solo se seleccionó imprimir
    if (imprimirChecked) {
      mandarAImprimir();
    } else {
      sinImpresion();
    }
  };

  const theme = useTheme();

  const checkboxStyle = {
    color: theme.bandera.colorSecundario,
    "&.Mui-checked": {
      color: theme.bandera.colorSecundario,
    },
  };
  return (
    <>
      <MenuSection />
      <Box
        sx={{
          position: "absolute",
          top: esKiosk ? "50%" : "40%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          width: isScreenWidthLessThan600 ? "95%" : "100%",
          height: isScreenWidthLessThan600 ? "70%" : "80%",
          borderRadius: "8px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            marginTop: isScreenWidthLessThan600 ? "60px" : "160px",
            fontWeight: "bold",
            fontSize: esKiosk ? "30px" : "19px",
            color: "#333",
            textAlign: "center",
            mt: isScreenWidthLessThan600 ? 7 : 25,
            mb: isScreenWidthLessThan600 ? 1 : 1,
            borderBottom: `2px solid ${theme.bandera.colorSecundario}`,
            paddingBottom: "4px",
            display: "inline-block",
          }}
        >
          <>
            SELECCIONE UNA O MÁS ACCIONES
            {isScreenWidthLessThan600 && <br />}
            PARA CONTINUAR
          </>
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            mt: 2,
            width: "90%",
          }}
        >
          {/* Mostrar opciones solo si no se están mostrando los inputs */}
          {!showInputs && (
            <>
              {/* Botón Mail */}
              <Box
                onClick={() => setMailChecked(!mailChecked)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  padding: `${isScreenWidthLessThan600 ? "25px" : "15px"} 30px`,
                  backgroundColor: "#EDEDED",
                  color: "#000",
                  borderRadius: "4px",
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#e0e0e0" },
                  mt: esKiosk ? 8 : 0,
                }}
              >
                {/* Cuadro con check */}
                <Box
                  sx={{
                    width: esKiosk ? 30 : 24,
                    height: esKiosk ? 30 : 24,
                    border: `2px solid ${theme.bandera.colorSecundario}`,
                    backgroundColor: mailChecked
                      ? theme.bandera.colorSecundario
                      : "transparent",
                    borderRadius: 1,
                    mr: 3,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {mailChecked && (
                    <CheckIcon
                      sx={{ fontSize: esKiosk ? 30 : 22, color: "#fff" }}
                    />
                  )}
                </Box>

                <EmailOutlinedIcon
                  sx={{ mr: 2, fontSize: esKiosk ? 40 : 28 }}
                />
                <Typography
                  sx={{ fontWeight: 600, fontSize: esKiosk ? 30 : 20 }}
                >
                  Mail
                </Typography>
              </Box>

              {/* Botón WhatsApp */}
              <Box
                onClick={() => setWhatsappChecked(!whatsappChecked)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  padding: `${isScreenWidthLessThan600 ? "15px" : "15px"} 30px`,
                  backgroundColor: "#EDEDED",
                  color: "#000",
                  borderRadius: "4px",
                  mt: esKiosk ? 3 : 1,
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#e0e0e0" },
                }}
              >
                {/* Cuadro con tilde blanca */}
                <Box
                  sx={{
                    width: esKiosk ? 30 : 24,
                    height: esKiosk ? 30 : 24,
                    border: `2px solid ${theme.bandera.colorSecundario}`,
                    backgroundColor: whatsappChecked
                      ? theme.bandera.colorSecundario
                      : "transparent",
                    borderRadius: 1,
                    mr: 3,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {whatsappChecked && (
                    <CheckIcon
                      sx={{ fontSize: esKiosk ? 30 : 22, color: "#fff" }}
                    />
                  )}
                </Box>

                <WhatsAppIcon sx={{ mr: 2, fontSize: esKiosk ? 40 : 28 }} />
                <Typography
                  sx={{ fontWeight: 600, fontSize: esKiosk ? 30 : 20 }}
                >
                  WhatsApp
                </Typography>
              </Box>

              {/* Botón Imprimir */}
              <Box
                onClick={() => setImprimirChecked(!imprimirChecked)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  padding: `${isScreenWidthLessThan600 ? "25px" : "15px"} 30px`,
                  backgroundColor: "#EDEDED",
                  color: "#000",
                  mt: esKiosk ? 3 : 1,
                  borderRadius: "4px",
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#e0e0e0" },
                }}
              >
                {/* Cuadro con tilde blanca */}
                <Box
                  sx={{
                    width: esKiosk ? 30 : 24,
                    height: esKiosk ? 30 : 24,
                    border: `2px solid ${theme.bandera.colorSecundario}`,
                    backgroundColor: imprimirChecked
                      ? theme.bandera.colorSecundario
                      : "transparent",
                    borderRadius: 1,
                    mr: 3,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {imprimirChecked && (
                    <CheckIcon
                      sx={{ fontSize: esKiosk ? 30 : 22, color: "#fff" }}
                    />
                  )}
                </Box>

                <ReceiptLongOutlinedIcon
                  sx={{ mr: 2, fontSize: esKiosk ? 40 : 28 }}
                />
                <Typography
                  sx={{ fontWeight: 600, fontSize: esKiosk ? 30 : 20 }}
                >
                  Imprimir
                </Typography>
              </Box>

              {/* Botón QR */}
              <Box
                onClick={() => setQrChecked(!qrChecked)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  padding: `${isScreenWidthLessThan600 ? "25px" : "15px"} 30px`,
                  backgroundColor: "#EDEDED",
                  color: "#000",
                  mt: esKiosk ? 3 : 1,
                  borderRadius: "4px",
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#e0e0e0" },
                }}
              >
                {/* Cuadro con tilde blanca */}
                <Box
                  sx={{
                    width: esKiosk ? 30 : 24,
                    height: esKiosk ? 30 : 24,
                    border: `2px solid ${theme.bandera.colorSecundario}`,
                    backgroundColor: qrChecked
                      ? theme.bandera.colorSecundario
                      : "transparent",
                    borderRadius: 1,
                    mr: 3,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {qrChecked && (
                    <CheckIcon
                      sx={{ fontSize: esKiosk ? 30 : 22, color: "#fff" }}
                    />
                  )}
                </Box>

                <QrCode2Icon sx={{ mr: 2, fontSize: esKiosk ? 40 : 28 }} />
                <Typography
                  sx={{ fontWeight: 600, fontSize: esKiosk ? 30 : 20 }}
                >
                  QR
                </Typography>
              </Box>
            </>
          )}

          {/* Campos de entrada condicionales */}
          {showInputs && mailChecked && (
            <TextField
              fullWidth
              label="Ingrese e-mail"
              variant="outlined"
              value={email}
              onChange={e => setEmail(e.target.value)}
              sx={{
                mt: esKiosk ? 8 : 1,
                fontSize: esKiosk ? 25 : 18,
                ...(esKiosk && { "& label": { fontSize: 25 } }),
              }}
              InputProps={{
                style: {
                  fontSize: esKiosk ? 25 : 18,
                },
              }}
            />
          )}

          {showInputs && whatsappChecked && (
            <TextField
              fullWidth
              label="Ingrese número de teléfono"
              variant="outlined"
              value={telefono}
              type="number"
              onChange={e => setTelefono(e.target.value)}
              sx={{
                mt: esKiosk ? 5 : 1,
                fontSize: esKiosk ? 25 : 18,
                ...(esKiosk && { "& label": { fontSize: 25 } }),
              }}
              InputProps={{
                style: {
                  fontSize: esKiosk ? 25 : 18,
                },
              }}
            />
          )}
          {showInputs && qrChecked && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mt: 0,
              }}
            >
              <img
                src={qrImageSrc}
                alt="Código QR"
                style={{
                  width: esKiosk ? "250px" : "150px",
                  height: esKiosk ? "250px" : "150px",
                  marginTop: esKiosk ? "20px" : "0px",
                }}
              />
            </Box>
          )}
        </Box>
        {/* Mostramos el spinner y el tiempo restante mientras cargamos */}
        {/* {loading && (
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 4 }}>
            <CircularProgress />
            <Typography sx={{ mt: 2, fontWeight: "bold" }}>{timeLeft} segundos restantes</Typography>
          </Box>
        )} */}
        <Button
          variant="contained"
          onClick={handleAceptar}
          sx={{
            boxShadow: 0,
            mt: esKiosk
              ? 10
              : isScreenWidthLessThan600
              ? showInputs
                ? 8
                : 3
              : showInputs
              ? 1
              : 3,
            fontWeight: "bold",
            fontSize: esKiosk ? 25 : 20,
            color:"black",
            backgroundColor: theme.bandera.colorSecundario,
            width: esKiosk ? "250px" : "200px",
            "&:hover": {
              backgroundColor: theme.bandera.colorSecundario,
            },
          }}
        >
          ACEPTAR
        </Button>
      </Box>
    </>
  );
};

export default DialogoEnviarFacturaPage;
